import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    tabLabel: {
      fontSize: "0.9rem"
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    },
    searchField: {
      width: "100%",
      marginTop: "5px"
    },
    barColorComplete: {
      backgroundColor: "green"
    },
    barColorIncomplete: {
      backgroundColor: "#3f51b5"
    },
    progressBackdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff"
    }
  })
);
